import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { CreateSet } from "./CreateSet";
import { SetsList } from "./SetsList";
import { useWod } from "../../context/WODContext";
import {
  getFormattedDate,
  getReadableShortDate,
  getWodDuration,
} from "../../utils/commons";
import SendIcon from "@mui/icons-material/Save";
import { SystemDialog } from "../../utils/Dialog";
import { useSnackbar } from "notistack";
import {
  fetchExercises,
  getTodaysWod,
  saveWod,
} from "../../services/WodService";
import { useTheme } from "@mui/material/styles";

export const CreateWOD = () => {
  const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);
  const theme = useTheme();

  const {
    setExercises,
    wodSets,
    setWodSets,
    setWodsLoading,
    wodDate,
    isEditing: isWodEditing,
  } = useWod();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    fetchExercises()
      .then((exercises) => {
        setExercises(exercises);
      })
      .catch((e) => {
        console.log("#### e", e);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUploadClick = () => {
    setShowConfirmDialog(true);
  };

  const handleConfirmDialog = () => {
    const formattedDate = isWodEditing ? wodDate : getFormattedDate();
    saveWod(formattedDate, wodSets, getWodDuration(wodSets))
      .then(() => {
        setShowConfirmDialog(false);
        enqueueSnackbar("WOD saved successfully!");
      })
      .catch((e) => {
        setShowConfirmDialog(false);
      });
  };

  const fetchTodaysWod = () => {
    setWodsLoading(true);
    getTodaysWod()
      .then((wodSetsList) => {
        setWodSets(wodSetsList);
        setWodsLoading(false);
      })
      .catch((er) => {
        setWodsLoading(false);
      });
  };

  useEffect(() => {
    if (!isWodEditing) {
      fetchTodaysWod();
    }
  }, []);

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "row",
        gap: 3,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      {/* Left: Create Set Form */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          overflow: "auto",
        }}
      >
        <CreateSet />
      </Box>

      {/* Right: Sets List */}
      <Box
        sx={{
          width: { md: 360 },
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        {wodSets.length > 0 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1.5,
              flexShrink: 0,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{ color: theme.palette.secondary.main }}
            >
              {isWodEditing
                ? getReadableShortDate(wodDate)
                : `Today: ${getReadableShortDate()}`}
            </Typography>
            <Button
              color="secondary"
              endIcon={<SendIcon />}
              variant="contained"
              size="small"
              onClick={handleUploadClick}
              sx={{ textTransform: "none", fontWeight: 600, borderRadius: 1.5 }}
            >
              Save WOD
            </Button>
          </Box>
        )}
        <SetsList />
      </Box>
      <SystemDialog
        component={
          <Typography variant="overline">
            {isWodEditing
              ? `Are you sure you want to update this workout plan ?`
              : `Are you sure you want to save todays workout ?`}
          </Typography>
        }
        open={showConfirmDialog}
        handleClose={() => setShowConfirmDialog(false)}
        handleConfirm={handleConfirmDialog}
        heading="Save Workout"
      />
    </Box>
  );
};
